import { render, staticRenderFns } from "./CmsProductList.vue?vue&type=template&id=00adfe5a&scoped=true&"
import script from "./CmsProductList.vue?vue&type=script&lang=js&"
export * from "./CmsProductList.vue?vue&type=script&lang=js&"
import style0 from "./CmsProductList.vue?vue&type=style&index=0&id=00adfe5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00adfe5a",
  null
  
)

export default component.exports